// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeopleSpeakerSvg from '@rsuite/icon-font/lib/people/PeopleSpeaker';
var PeopleSpeaker = createSvgIcon({
  as: PeopleSpeakerSvg,
  ariaLabel: 'people speaker',
  category: 'people',
  displayName: 'PeopleSpeaker'
});
export default PeopleSpeaker;